import axios from 'axios';
import {baseURL} from '../Constants';

const url = `${baseURL}parameters/`;

export function getParameterList() {
  return axios
    .get(url)
    .then((response) => response)
    .catch((response) => response);
}

export function addParameter(data) {
  return axios
    .post(url, data)
    .then((response) => response)
    .catch((response) => response);
}

export function updateParameter(data) {
  return axios
    .put(`${url}${data.id}/`, data)
    .then((response) => response)
    .catch((response) => response);
}

export function deleteParameter(parameter) {
  return axios
    .delete(`${url}${parameter.id}/`, parameter)
    .then((response) => response)
    .catch((response) => response);
}



// WEBPACK FOOTER //
// ./src/parameter/parameterApi.js